<div class="file-grouping" [formGroup]="formGroupContainer">
  <mat-form-field>
    <mat-label>Original filename</mat-label>
    <input matInput formControlName="filename" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Label</mat-label>
    <input matInput formControlName="description" placeholder="Label" />
  </mat-form-field>
</div>

<mood-admin-raster-layer-form [formGroup]="formGroupContainer"></mood-admin-raster-layer-form>
